export default  {"src":"/_next/static/image/public/assets/icons/bank-of-ireland-text.f1ea90f672b1b8ed8981136a7d149975.svg","height":10,"width":92};